module.exports = __webpack_public_path__ + "static/media/File-Export.47da629a.svg";